module.exports = __webpack_public_path__ + "static/img/16071B_X_01_2_3_20170801_fit.970acc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/16071B_X_01_2_3_20170801_fit.png
// module id = K60/
// module chunks = 0